import { jsx as _jsx } from "react/jsx-runtime";
import { BKJToggleInputComponentMap } from './BKJToggleInput.constants.js';
export const BKJToggleInput = ({ variant, children, ...rest }) => {
    const Component = BKJToggleInputComponentMap[variant];
    return (_jsx(Component, { ...rest, variant: variant, children: children }));
};
//# sourceMappingURL=BKJToggleInput.js.map